import { mergeQueryKeys } from '@lukemorales/query-key-factory';

export const joinQueries = mergeQueryKeys();
export type JoinQueries = typeof joinQueries;
